module.exports = __webpack_public_path__ + "img/rule-header.6e32e2d0.png";